import { Component, h } from 'preact'
import { ProductAreaType } from '../../../control-components/product-areas/ProductAreaSelect'
import Phrase from '../../../libs/translationsUtils/phrase'
import InputGroup from '../../../control-components/ui-components/InputGroup'
import qs from 'qs'
import Portal from 'preact-portal'

interface Props {
  productAreas: Array<ProductAreaType>,
  selectedProductArea: null | string
}

interface State {
  selectedProductArea: null | string,
  selectedProductAreaBeforeFiltersApply: null | string,
  setPortal: boolean
}

export class ProductAreaFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedProductArea: props.selectedProductArea === null ? null : props.selectedProductArea,
      selectedProductAreaBeforeFiltersApply: null,
      setPortal: false
    }
    this.setQueryParams = this.setQueryParams.bind(this)
    this.setSelectedProductArea = this.setSelectedProductArea.bind(this)
    this.updatePortalSetting = this.updatePortalSetting.bind(this)
  }

  setQueryParams (newProductArea: string | null) {
    const searchQuery = window.location.search
    let queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })

    delete queryParameters?.filters?.productArea

    let newQuery = newProductArea === null ? { filters: queryParameters?.filters || {} } : { filters: { ...queryParameters?.filters || {}, productArea: [newProductArea] } }

    let combinedQuery = { ...queryParameters, ...newQuery }

    delete combinedQuery?.page

    window.history.pushState('', '', `?${qs.stringify(combinedQuery)}`)
  }

  setSelectedProductArea (newProductArea: string | null) {
    this.setState({ selectedProductArea: newProductArea })
    this.setQueryParams(newProductArea)
  }

  updatePortalSetting (evt: CustomEvent) {
    this.setState({
      selectedProductAreaBeforeFiltersApply: this.state.selectedProductArea,
      setPortal: evt.detail.display
    })
  }

  ListItem (name: string | null) {
    return (
      <li
        className={this.state.selectedProductArea === name ? 'selected' : ''}
        onClick={() => this.setSelectedProductArea(name)}
        onKeyUp={(e) => e.code === 'Enter' ? this.setSelectedProductArea(name) : null}
        role='button'
        tabIndex={0}
      >
        <div className='vertical-line' />
        {
          name === null ? <Phrase p='all.products' /> : <span>{ name }</span>
        }
      </li>
    )
  }

  componentDidMount () {
    if (typeof window === 'undefined') {
      return
    }
    window.addEventListener('filter', (this.updatePortalSetting) as EventListener)
    window.addEventListener('productAreaFilterRemoval', () => this.setSelectedProductArea(null))
    window.addEventListener('revertFilters', () => this.setSelectedProductArea(this.state.selectedProductAreaBeforeFiltersApply))
    window.addEventListener('resetFilters', () => this.setSelectedProductArea(null))
  }

  componentWillUnmount () {
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('filter', (this.updatePortalSetting) as EventListener)
    window.removeEventListener('productAreaFilterRemoval', () => this.setSelectedProductArea(null))
    window.removeEventListener('revertFilters', () => this.setSelectedProductArea(this.state.selectedProductAreaBeforeFiltersApply))
    window.removeEventListener('resetFilters', () => this.setSelectedProductArea(null))
  }

  render ({ productAreas }: Props, { selectedProductArea, setPortal }: State) {
    return (
      <div>
        <div className='box__content box__pad ideation-filters is-hidden-M'>
          <h3 className='widget-title'><Phrase p='filter.by.product' /></h3>
          <ul className='ideation-filters__product-area'>
            {
              this.ListItem(null)
            }
            {
              productAreas.map(({ name }) => this.ListItem(name))
            }
          </ul>
        </div>
        {
          setPortal ? (
            <Portal into='.instant-search__results-wrapper-filters'>
              <div className='box__content box__pad ideation-filters'>
                <h3 className='widget-title'><Phrase p='filter.by.product' /></h3>
                <ul className='ideation-filters__product-area'>
                  {
                    this.ListItem(null)
                  }
                  {
                    productAreas.map(({ name }) => this.ListItem(name))
                  }
                </ul>
              </div>
            </Portal>
          ) : null
        }
      </div>
    )
  }
}

interface PropsForConfigurator {
  title: string,
  onChange: (state: {title: string}) => void
}

interface StateForConfigurator {
  title: string
}

export class ProductAreaFilterWithHelp extends Component<PropsForConfigurator, StateForConfigurator> {
  constructor (props: PropsForConfigurator) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange(this.state))
  }

  render (_: PropsForConfigurator, { title }: StateForConfigurator) {
    return (
      <div className=''>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
      </div>
    )
  }
}

export default ProductAreaFilter
